/* globals theme_url */

import { debounce } from 'throttle-debounce'

// Initialize and add the map
let map;

async function initMap() {
    // The location of Uluru
    const position = { lat: 48.4880096, lng: -122.3328795 };

    // Request needed libraries.
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

    // The map, centered at Burlington
    map = new Map(document.getElementById("location-map"), {
        zoom: 14,
        center: position,
        mapId: "c5e0908e61299064d3a175bc",
        streetViewControl: false,
        mapTypeControl: false
    });

    // Define the path to the custom SVG marker
    //const theme_url = window.theme_url || '';
    const svgUrl = theme_url + '/img/map-pin.svg';

    // Get the list of location coordinates, href, and name
    const markerElements = Array.from(document.querySelectorAll('.acf-map-marker'));

    const locations = markerElements.map(li => {
        return {
            lat: parseFloat(li.dataset.lat),
            lng: parseFloat(li.dataset.lng),
            content: li.innerHTML
        };
    });

    const bounds = new google.maps.LatLngBounds();

    // Create a single InfoWindow instance
    const infoWindow = new google.maps.InfoWindow();

    const markers = locations.map((loc, i) => {

        const position = { lat: loc.lat, lng: loc.lng };
        // Create a custom button element for the marker
        const svgElement = document.createElement('button');
        svgElement.type = 'button';
        svgElement.className = 'map-button-reset';
        svgElement.innerHTML = `<img src="${svgUrl}" alt="Map marker" style="width:65px;height:65px;">`;
        svgElement.setAttribute('aria-label', 'Map marker: ' + (loc.content.replace(/<[^>]+>/g, '').trim() || 'Location'));

        // Open infobox on button click or keyboard activation
        svgElement.addEventListener('click', (e) => {
            e.preventDefault();
            infoWindow.setContent(`${loc.content}`);
            infoWindow.open(map, marker);
        });

        const marker = new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: position,
            content: svgElement,
            title: loc.content,
            gmpClickable: true
        });

        // Extend the bounds of the map to contain the pin  
        bounds.extend(position);

        // Add click listener to show infobox with the marker's HTML content
        marker.addListener('click', () => {
            infoWindow.setContent(`${loc.content}`);
            infoWindow.open(map, marker);
        });

        return marker;
    });

    // Adjust the map to fit the bounds
    setTimeout(() => {
        map.fitBounds(bounds);
    }, 200);

    // On window resize, refit the bounds to ensure all markers are visible
    window.addEventListener('resize', debounce(200, () => {
        map.fitBounds(bounds);
    }));

}

document.addEventListener('DOMContentLoaded', () => {
    initMap();
});
